// App.js

import { useAuth } from "react-oidc-context";
import { useNavigate } from 'react-router-dom';
import AuthCallback from "../functions/AuthCallback";

function SocialLoginFBHosted() {
  const navigate=useNavigate();

    const firebaseAuthUrl = (provider) => {
      const authUrl = `https://upskill-semion.firebaseapp.com/__/auth/handler?providerId=${provider}&continueUrl=${window.location.origin}/auth-callback`;
      window.location.href = authUrl;
    };

  return (
<div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Firebase Hosted Authentication</h1>
      <button onClick={() => firebaseAuthUrl("google.com")}>Login with Google</button>
      <button onClick={() => firebaseAuthUrl("facebook.com")}>Login with Facebook</button>
    </div>
  );
}
  
export default SocialLoginFBHosted;